import { format } from "date-fns";

const formatDate = (dateTimestamp?: number | null, formatting: string = "MM/dd/yyyy"): string =>
    dateTimestamp ? format(dateTimestamp * 1000, formatting) : "-";

export default formatDate;
